import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 494.942 494.942",
  "content": "<symbol viewBox=\"0 0 494.942 494.942\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\"><path d=\"M35.353 0l424.236 247.471L35.353 494.942z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol